// src/routes/ProtectedLayout.jsx
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { ContextGlobal } from "../context"; // ajuste o caminho se precisar
import SideBar from "../components/sidebar"; // seu SideBar atual
import FloatingSiChat from "../components/si-advisor/FloatingSiChat";
import AssistenteBloqueado from "../components/si-advisor/AssistenteBloqueado";
import { STATUS_LIBERADO } from "../middleware/permissionMiddleware";

export default function ProtectedLayout() {
	const { loadingPermissions, modulopermitted, listPermissionsData } = useContext(ContextGlobal);

	const temAssistente = (modulopermitted ?? []).some(
		(item) => item.modulo === "ASSISTENTE IA" && STATUS_LIBERADO.includes(item.status),
	);

	if (loadingPermissions) {
		return <div style={{ padding: 24 }}>Carregando...</div>;
	}

	// o conteúdo da rota entra no prop "render"
	return (
		<>
			<SideBar render={<Outlet />} />
			{temAssistente && (listPermissionsData?.cad_financeiro ? <FloatingSiChat /> : <AssistenteBloqueado />)}
		</>
	);
}
